import * as React from "react";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";


interface CloseButtonProps {
    style?: React.CSSProperties;
    onClick?: () => void;
}


export default function CloseButton(props: CloseButtonProps) {

    return  <IconButton
        style={props.style}
        edge="end"
        aria-label="close"
        onClick={props.onClick}
    >
        <CloseIcon/>
    </IconButton>
}